import { selectPromoInventory } from './index';
import { IApplicationState } from '../../types/redux';

export function selectNewbuildingsForPromoInventory(state: IApplicationState) {
  const promoInventory = selectPromoInventory(state);

  return promoInventory.newbuildings;
}
